import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class MenuService {
  menus = [
    //old
    {
      code: "performance",
      title: "Performance",
      Url: "/dashboard/performance",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "tableau_de_bord",
      current_header: ""
    },

    //old

    {
      code: "activite",
      title: "Activité",
      Url: "/mon-portefeuille/mes-dossiers",
      icon: "fa fa-tasks",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "workflow",
      current_header: ""
    },
    {
      code: "dossier",
      title: "Dossier",
      icon: "fa fa-folder-open",
      active: "",
      type: "dropdown_l1",
      permission: "for_all",
      header_id: "workflow",
      current_header: ""
    },
    /*{
            code: 'comitecredit',
            title: 'Comité de crédit',
            Url:'/comite-credit/all-comite',
            icon: 'fa fa-calendar',
            active: '',
            permission:'comite_credit',
            type: 'simple',
            header_id:'workflow',
            current_header:''
        },*/
    {
      code: "comitecredit",
      title: "Comité de crédit",
      icon: "fa fa-folder-open",
      active: "",
      type: "dropdown_l1",
      permission: "comite_credit",
      header_id: "workflow",
      current_header: ""
    },
    //

    //BI
    {
      code: "activite",
      title: "Activité",
      Url: "/reporting/audience",
      icon: "fa fa-line-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "bi",
      current_header: ""
    },
    //BI

    //
    {
      code: "suivi-portefeuille-historique-import",
      title: "Historique importation",
      Url: "/suivi-portefeuille/historique-importation",
      icon: "fa fa-cloud-upload",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "suivi-portefeuille",
      current_header: ""
    },
    //
    {
      code: "suivi-portefeuille-vue-portefeuille",
      title: "Vue portefeuille",
      Url: "/suivi-portefeuille/vue-portefeuille",
      icon: "fa fa-cloud-upload",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "suivi-portefeuille",
      current_header: ""
    },

    {
      code: "suivi-portefeuille-provisions",
      title: "Provisions",
      Url: "/suivi-portefeuille/provisions",
      icon: "fa fa-money",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "suivi-portefeuille",
      current_header: ""
    },

   /* {
      code: "suivi-portefeuille-compte",
      title: "Compte client",
      icon: "fa fa-bank",
      active: "",
      type: "dropdown_l1",
      permission: "for_all",
      header_id: "suivi-portefeuille",
      current_header: ""
    },*/

    /*{
            code: 'suivi-portefeuille-tous-dossiers',
            title: 'Dossier de crédit',
            Url:'/suivi-portefeuille/dossiers',
            icon: 'fa fa-money',
            active: '',
            permission:'for_all',
            type: 'simple',
            header_id:'suivi-portefeuille',
            current_header:''
        },*/
   /* {
      code: "suivi-portefeuille-dossier",
      title: "Dossier de crédit",
      icon: "fa fa-money",
      active: "",
      type: "dropdown_l1",
      permission: "for_all",
      header_id: "suivi-portefeuille",
      current_header: ""
    },*/

    //
    {
      code: "support-client-contact-support-client",
      title: "Contact",
      Url: "/support-client/contact-support-client",
      icon: "fa fa-line-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "support-client",
      current_header: ""
    },

    ///////////////////////////////////////////////////////////////////////////////////////////
    {
      code: "personnel",
      title: "Personnel",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "new_dashboard_personnel",
      type: "dropdown_l1",
      header_id: "new_tableau_de_bord",
      current_header: ""
    },
    /*{
      code: "departement",
      title: "Département",
      Url: "/new-dashboard/departement",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "dropdown_l1",
      header_id: "new_tableau_de_bord",
      current_header: "",
    },*/
    {
      code: "global",
      title: "Global",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "new_dashboard_global",
      type: "dropdown_l1",
      header_id: "new_tableau_de_bord",
      current_header: ""
    },
    {
      code: "corporate",
      title: "Corporate",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "new_dashboard_corporate",
      type: "dropdown_l1",
      header_id: "new_tableau_de_bord",
      current_header: ""
    },
    {
      code: "particulier",
      title: "Retail",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "new_dashboard_retrail",
      type: "dropdown_l1",
      header_id: "new_tableau_de_bord",
      current_header: ""
    },
    {
      code: "professionnel",
      title: "Professionnel",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "new_dashboard_professionnel",
      type: "dropdown_l1",
      header_id: "new_tableau_de_bord",
      current_header: ""
    },
    {
      code: "product_program",
      title: "Product program",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "new_dashboard_product_program",
      type: "dropdown_l1",
      header_id: "new_tableau_de_bord",
      current_header: ""
    },
    {
      code: "credit",
      title: "Crédit",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "new_dashboard_credit",
      type: "dropdown_l1",
      header_id: "new_tableau_de_bord",
      current_header: ""
    },
    {
      code: "juridique",
      title: "Juridique",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "new_dashboard_juridique",
      type: "dropdown_l1",
      header_id: "new_tableau_de_bord",
      current_header: ""
    },

    {
      code: "suivi_portefeuille",
      title: "suivi portefeuille",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "new_dashboard_juridique",
      type: "dropdown_l1",
      header_id: "new_tableau_de_bord",
      current_header: ""
    },

    {
      code: "new_audit",
      title: "Audit",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "new_dashboard_audit",
      type: "dropdown_l1",
      header_id: "new_tableau_de_bord",
      current_header: ""
    },

    {
      code: "client",
      title: "client",
      Url: "/crm/client",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "client",
      type: "simple",
      header_id: "client",
      current_header: ""
    },

    {
      code: "tous_les_clients",
      title: "Tous les clients",
      Url: "/crm/client-all",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "client_tous_clients",
      type: "simple",
      header_id: "client",
      current_header: ""
    },
    {
      code: "importations",
      title: "Importations",
      Url: "/crm/importation-transactions",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "client_importation",
      type: "simple",
      header_id: "client",
      current_header: ""
    }

    ////////////////////////////////////////////////////new
  ];

  menus_l2 = [
    //
    {
      code: "detail_corporate",
      title: "Corporate",
      icon: "fa fa-dashboard",
      active: "",
      type: "dropdown_l2",
      permission: "dashboard_corporate",
      header_id: "detail",
      current_header: ""
    },
    {
      code: "detail_particulier",
      title: "Particulier",
      icon: "fa fa-dashboard",
      active: "",
      type: "dropdown_l2",
      permission: "dashboard_particulier",
      header_id: "detail",
      current_header: ""
    },
    {
      code: "detail_professionnel",
      title: "Professionnel",
      icon: "fa fa-dashboard",
      active: "",
      type: "dropdown_l2",
      permission: "dashboard_professionnel",
      header_id: "detail",
      current_header: ""
    },

    {
      code: "detail_product_program",
      Url: "/product-program/dashboard/product-program",
      title: "Product program",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "product_program",
      header_id: "detail",
      current_header: ""
    },

    //
    {
      code: "dossier_corporate",
      icon: "fa fa-folder-open",
      title: "Corporate",
      Url: "/cnce-corporate/dossier-historique-all",
      active: "",
      type: "simple",
      permission: "corporate",
      header_id: "dossier",
      current_header: ""
    },
    {
      code: "historiqueclient_particulier",
      icon: "fa fa-folder-open",
      title: "Particulier",
      Url: "/retail/dossier-historique-all",
      active: "",
      type: "simple",
      permission: "particulier",
      header_id: "dossier",
      current_header: ""
    },
    {
      code: "historiqueclient_professionnel",
      icon: "fa fa-folder-open",
      title: "Professionnel",
      Url: "/cnce-professionnel/dossier-historique-all",
      active: "",
      type: "simple",
      permission: "professionnel",
      header_id: "dossier",
      current_header: ""
    },
    {
      code: "dossier_productprogram",
      icon: "fa fa-folder-open",
      title: "Product Program",
      Url: "/product-program/dossier-historique",
      active: "",
      type: "simple",
      permission: "product_program",
      header_id: "dossier",
      current_header: ""
    },
    {
      code: "dossier_contentieux",
      icon: "fa fa-folder-open",
      title: "Contentieux",
      Url: "/contentieux/dossier-historique",
      active: "",
      type: "simple",
      permission: "contentieux",
      header_id: "dossier",
      current_header: ""
    },
    //

    {
      code: "historiqueclient_corporate",
      title: "Corporate",
      Url: "/cnce-corporate/historique-client/corporate",
      active: "",
      type: "simple",
      permission: "historique_client",
      header_id: "historiqueclient",
      current_header: ""
    },
    {
      code: "historiqueclient_particulier",
      title: "Particulier",
      Url: "/cnce-corporate/historique-client/particulier",
      active: "",
      type: "simple",
      permission: "historique_client",
      header_id: "historiqueclient",
      current_header: ""
    },
    {
      code: "historiqueclient_professionnel",
      title: "Professionnel",
      Url: "/cnce-corporate/historique-client/professionnel",
      active: "",
      type: "simple",
      permission: "historique_client",
      header_id: "historiqueclient",
      current_header: ""
    },
    //

    //
    {
      code: "comitecredit_calendrier",
      title: "Calendrier",
      Url: "/comite-credit/calendrier",
      active: "",
      type: "simple",
      permission: "for_all",
      header_id: "comitecredit",
      current_header: ""
    },
    {
      code: "comitecredit_comite_interne",
      title: "Comité interne",
      Url: "/comite-credit/comite-interne",
      active: "",
      type: "simple",
      permission: "for_all",
      header_id: "comitecredit",
      current_header: ""
    },
    {
      code: "comitecredit_comite_superieur",
      title: "Comité supérieur",
      Url: "/comite-credit/comite-superieur",
      active: "",
      type: "simple",
      permission: "for_all",
      header_id: "comitecredit",
      current_header: ""
    },
    {
      code: "comitecredit_comite_declassement",
      title: "Comité déclassement",
      Url: "/comite-credit/comite-declassement",
      active: "",
      type: "simple",
      permission: "for_all",
      header_id: "comitecredit",
      current_header: ""
    },
    {
      code: "comitecredit_etat_definitif",
      title: "Etat définitif",
      Url: "/comite-credit/etat-definitif",
      active: "",
      type: "simple",
      permission: "for_all",
      header_id: "comitecredit",
      current_header: ""
    },
    //

    {
      code: "reporting_sla_agent",
      title: "SLA Agent",
      Url: "/reporting/sla-agent",
      active: "",
      type: "simple",
      permission: "reporting_sla_agent",
      header_id: "reporting",
      current_header: ""
    },
    {
      code: "reporting_corporate",
      title: "Corporate",
      Url: "/reporting/corporate/etat-reglementaire",
      active: "",
      type: "simple",
      permission: "reporting_corporate",
      header_id: "reporting",
      current_header: ""
    },
    {
      code: "reporting_particulier",
      title: "Particulier",
      Url: "/reporting/particulier/etat-reglementaire",
      active: "",
      type: "simple",
      permission: "reporting_particulier",
      header_id: "reporting",
      current_header: ""
    },
    {
      code: "reporting_professionnel",
      title: "Professionnel",
      Url: "/reporting/professionnel/etat-reglementaire",
      active: "",
      type: "simple",
      permission: "reporting_professionnel",
      header_id: "reporting",
      current_header: ""
    },
    //
    {
      code: "audit_connexion",
      title: "Connexions",
      Url: "/audit/historique-connexion",
      active: "",
      type: "simple",
      permission: "audit_historiqueConnexion",
      header_id: "audit",
      current_header: ""
    },
    {
      code: "audit_log",
      title: "Logs",
      Url: "/audit/historique-log",
      active: "",
      type: "simple",
      permission: "audit_Log",
      header_id: "audit",
      current_header: ""
    },
    //

    //suivi portefeuille
    {
      code: "suivi-portefeuille-comptes",
      title: "Tous les clients",
      Url: "/suivi-portefeuille/comptes",
      active: "",
      type: "simple",
      permission: "for_all",
      header_id: "suivi-portefeuille-compte",
      current_header: ""
    },
    {
      code: "suivi-portefeuille-comptes-gesionnaite",
      title: "Gestionnaire",
      Url: "/suivi-portefeuille/comptes-by-gestionnaire",
      active: "",
      type: "simple",
      permission: "for_all",
      header_id: "suivi-portefeuille-compte",
      current_header: ""
    },
    {
      code: "suivi-portefeuille-tous-dossiers",
      title: "Tous les dossiers",
      Url: "/suivi-portefeuille/dossiers",
      active: "",
      type: "simple",
      permission: "for_all",
      header_id: "suivi-portefeuille-dossier",
      current_header: ""
    },
    {
      code: "suivi-portefeuille-dossier-gesionnaite",
      title: "Gestionnaire",
      Url: "/suivi-portefeuille/dossiers-by-gestionnaire",
      active: "",
      type: "simple",
      permission: "for_all",
      header_id: "suivi-portefeuille-dossier",
      current_header: ""
    },
    //suivi portefeuille

    ////////////////////////////////////////////////////////// NEW DASHBOARD

    //personnel
    
    {
      code: "personnel_mes_performances",
      Url: "/personnel/performance",
      title: "Mes performances",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "for_all",
      header_id: "personnel",
      current_header: ""
    },
    {
      code: "personnel_mes_dossiers",
      Url: "/new-dashboard/personnel/dossiers-card-list",
      title: "Mes dossiers",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "new_dashboard_personnel_dossers",
      header_id: "personnel",
      current_header: ""
    },
    {
      code: "personnel_mon_portefeuille",
      Url: "/new-dashboard/personnel/mon-portefeuille",
      title: "Mon portefeuille",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "new_dashboard_personnel_portefeuille",
      header_id: "personnel",
      current_header: ""
    },
    /*{
      code: "personnel_mes_tache",
      Url: "/mon-portefeuille/mes-taches-en-cours",
      title: "Mes tâches",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "new_dashboard_personnel_taches",
      header_id: "personnel",
      current_header: ""
    },*/
    /*{
      code: "personnel_mon_historique",
      Url: "/mon-portefeuille/mon-historique-dossier",
      title: "Mon historique",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "new_dashboard_personnel_historique",
      header_id: "personnel",
      current_header: ""
    },*/
    //personnel

    //departement
    {
      code: "departement_production",
      Url: "javascript:;",
      title: "Production",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "for_all",
      header_id: "departement",
      current_header: ""
    },
    {
      code: "departement_dossier",
      Url: "javascript:;",
      title: "Dossiers",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "for_all",
      header_id: "departement",
      current_header: ""
    },
    {
      code: "departement_qos",
      Url: "javascript:;",
      title: "QOS",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "for_all",
      header_id: "departement",
      current_header: ""
    },
    {
      code: "departement_productivite",
      Url: "/new-dashboard/departement/productivite",
      title: "Productivité",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "for_all",
      header_id: "departement",
      current_header: ""
    },
    //departement

    //global
    {
      code: "global_portefeuille",
      Url: "/new-dashboard/global/portefeuille",
      title: "Portefeuille",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "new_dashboard_global_portefeuille",
      header_id: "global",
      current_header: ""
    },
    {
      code: "global_productivite",
      Url: "/new-dashboard/global/productivite",
      title: "Productivité",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "new_dashboard_global_productivite",
      header_id: "global",
      current_header: ""
    },
    //global

    //corporate
    {
      code: "corporate_production",
      title: "Production",
      Url: "/new-dashboard/marche/corporate/production",
      active: "",
      type: "simple",
      permission: "new_dashboard_corporate_production",
      header_id: "corporate",
      current_header: ""
    },
    {
      code: "corporate_dossier",
      title: "Dossiers",
      Url: "/new-dashboard/marche/corporate/dossiers-card-list",
      active: "",
      type: "simple",
      permission: "new_dashboard_corporate_dossiers",
      header_id: "corporate",
      current_header: ""
    },
    {
      code: "corporate_qos",
      title: "QOS",
      Url: "/new-dashboard/marche/corporate/quality-of-service",
      active: "",
      type: "simple",
      permission: "new_dashboard_corporate_qos",
      header_id: "corporate",
      current_header: ""
    },
    {
      code: "corporate_productivite",
      title: "Productivité",
      Url: "/new-dashboard/marche/corporate/productivite",
      active: "",
      type: "simple",
      permission: "new_dashboard_corporate_productivite",
      header_id: "corporate",
      current_header: ""
    },
  
    //corporate

    //particulier
    {
      code: "particulier_production",
      title: "Production",
      Url: "/new-dashboard/particulier/production",
      active: "",
      type: "simple",
      permission: "new_dashboard_particulier_production",
      header_id: "particulier",
      current_header: ""
    },
    /* {
      code: "particulier_dossier",
      title: "Dossiers",
      Url: "/retail/dossier-historique-new",
      active: "",
      type: "simple",
      permission: "new_dashboard_particulier_dossiers",
      header_id: "particulier",
      current_header: ""
    }, */

    {
      code: "particulier_dossier",
      title: "Dossiers",
      Url: "/new-dashboard/marche/particulier/dossiers-card-list",
      active: "",
      type: "simple",
      permission: "new_dashboard_particulier_dossiers",
      header_id: "particulier",
      current_header: ""
    },
    {
      code: "particulier_qos",
      title: "QOS",
      Url: "/new-dashboard/particulier/qos",
      active: "",
      type: "simple",
      permission: "new_dashboard_particulier_qos",
      header_id: "particulier",
      current_header: ""
    },
    {
      code: "particulier_productivite",
      title: "Productivité",
      Url: "/new-dashboard/particulier/productivite",
      active: "",
      type: "simple",
      permission: "new_dashboard_particulier_productivite",
      header_id: "particulier",
      current_header: ""
    },
    /*{
      code: "particulier_suivi_portefeuille",
      title: "Suivi portefeuille",
      Url: "javascript:;",
      active: "",
      type: "simple",
      permission: "new_dashboard_particulier_suivi_portefeuille",
      header_id: "particulier",
      current_header: ""
    },*/
    //particulier

    //professionnel
    {
      code: "professionnel_production",
      title: "Production",
      Url: "/new-dashboard/professionnel/production",
      active: "",
      type: "simple",
      permission: "new_dashboard_professionnel_production",
      header_id: "professionnel",
      current_header: ""
    },
    /* {
      code: "professionnel_dossier",
      title: "Dossiers",
      Url: "/cnce-professionnel/dossier-historique-new",
      active: "",
      type: "simple",
      permission: "new_dashboard_professionnel_dossiers",
      header_id: "professionnel",
      current_header: ""
    },*/

    {
      code: "professionnel_dossier",
      title: "Dossiers",
      Url: "/new-dashboard/marche/professionnel/dossiers-card-list",
      active: "",
      type: "simple",
      permission: "new_dashboard_professionnel_dossiers",
      header_id: "professionnel",
      current_header: ""
    },
    {
      code: "professionnel_qos",
      title: "QOS",
      Url: "/new-dashboard/professionnel/qos",
      active: "",
      type: "simple",
      permission: "new_dashboard_professionnel_qos",
      header_id: "professionnel",
      current_header: ""
    },
    {
      code: "professionnel_productivite",
      title: "Productivité",
      Url: "/new-dashboard/professionnel/productivite",
      active: "",
      type: "simple",
      permission: "new_dashboard_professionnel_productivite",
      header_id: "professionnel",
      current_header: ""
    },
    /*{
      code: "professionnel_suivi_portefeuille",
      title: "Suivi portefeuille",
      Url: "javascript:;",
      active: "",
      type: "simple",
      permission: "new_dashboard_professionnel_suivi_portefeuille",
      header_id: "professionnel",
      current_header: ""
    },*/
    //professionnel

    //product-program
    {
      code: "product_program_production",
      title: "Production",
      Url: "/new-dashboard/product-program/production",
      active: "",
      type: "simple",
      permission: "new_dashboard_product_program_production",
      header_id: "product_program",
      current_header: ""
    },
    {
      code: "product_program_dossier",
      title: "Dossiers",
      Url: "/product-program/dossier-historique-new",
      active: "",
      type: "simple",
      permission: "new_dashboard_product_program_dossiers",
      header_id: "product_program",
      current_header: ""
    },
    {
      code: "product_program_qos",
      title: "QOS",
      Url: "/new-dashboard/product-program/qos",
      active: "",
      type: "simple",
      permission: "new_dashboard_product_program_qos",
      header_id: "product_program",
      current_header: ""
    },
    {
      code: "product_program_productivite",
      title: "Productivité",
      Url: "/new-dashboard/product-program/productivite",
      active: "",
      type: "simple",
      permission: "new_dashboard_product_program_productivite",
      header_id: "product_program",
      current_header: ""
    },
    {
      code: "product_program_synthese",
      title: "Synthèse",
      Url: "/product-program/dashboard/product-program",
      active: "",
      type: "simple",
      permission: "new_dashboard_product_program_synthese",
      header_id: "product_program",
      current_header: ""
    },
    /*{
      code: "product_program_suivi_portefeuille",
      title: "Suivi portefeuille",
      Url: "javascript:;",
      active: "",
      type: "simple",
      permission: "new_dashboard_product_program_suivi_portefeuille",
      header_id: "product_program",
      current_header: ""
    },*/
    //product-program

    //juridique
    {
      code: "juridique_production",
      Url: "/new-dashboard/direction-juridique/production",
      title: "Production",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "new_dashboard_juridique_production",
      header_id: "juridique",
      current_header: ""
    },
    {
      code: "juridique_dossier",
      Url: "/new-dashboard/direction-juridique/dossiers-card-list",
      title: "Dossiers",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "new_dashboard_juridique_dossiers",
      header_id: "juridique",
      current_header: ""
    },
    {
      code: "juridique_qos",
      Url: "/new-dashboard/direction-juridique/qos",
      title: "QOS",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "new_dashboard_juridique_qos",
      header_id: "juridique",
      current_header: ""
    },
    {
      code: "juridique_productivite",
      Url: "/new-dashboard/direction-juridique/productivite",
      title: "Productivité",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "new_dashboard_juridique_productivite",
      header_id: "juridique",
      current_header: ""
    },
    //juridique

    // **Begin**suivi portefeuille**

    {
      code: "portefeuille_risque_suivi_portefeuille",
      Url: "/new-dashboard/suivi-portefeuille/portefeuille-risque",
      title: "Portefeuille risque",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "new_dashboard_juridique_productivite",
      header_id: "suivi_portefeuille",
      current_header: ""
    },

    {
      code: "impayer_suivi_portefeuille",
      Url: "/new-dashboard/suivi-portefeuille/dossier-impaye",
      title: "Impayé",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "new_dashboard_juridique_productivite",
      header_id: "suivi_portefeuille",
      current_header: ""
    },

    {
      code: "creance_restructure_suivi_portefeuille",
      Url: "/new-dashboard/suivi-portefeuille/creance-restructure",
      title: "Créances restructurées",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "new_dashboard_juridique_dossiers",
      header_id: "suivi_portefeuille",
      current_header: ""
    },

   

    {
      code: "provision_suivi_portefeuille",
      Url: "/new-dashboard/suivi-portefeuille/dossier-provision",
      title: "Provision",
      icon: "fa fa-dashboard",
      active: "",
      type: "simple",
      permission: "new_dashboard_juridique_productivite",
      header_id: "suivi_portefeuille",
      current_header: ""
    },
    
    // **End**suivi portefeuille**
    //Credit
    {
      code: "credit_production",
      title: "Production",
      Url: "/new-dashboard/credit/production",
      active: "",
      type: "simple",
      permission: "new_dashboard_credit_production",
      header_id: "credit",
      current_header: ""
    },
    {
      code: "credit_dossier",
      title: "Dossiers",
      Url: "/new-dashboard/credit/dossiers-card-list",
      active: "",
      type: "simple",
      permission: "new_dashboard_credit_dossiers",
      header_id: "credit",
      current_header: ""
    },
    {
      code: "credit_quality_of_service",
      title: "QOS",
      Url: "/new-dashboard/credit/quality-of-service",
      active: "",
      type: "simple",
      permission: "new_dashboard_credit_qos",
      header_id: "credit",
      current_header: ""
    },
    {
      code: "credit_productivite",
      title: "Productivité",
      Url: "/new-dashboard/credit/productivite",
      active: "",
      type: "simple",
      permission: "new_dashboard_credit_qos",
      header_id: "credit",
      current_header: ""
    },
    //credit

    //audit
    {
      code: "new_audit_log",
      title: "Logs",
      Url: "/reporting/historique-log",
      active: "",
      type: "simple",
      permission: "new_dashboard_audit_logs",
      header_id: "new_audit",
      current_header: ""
    }
    //audit
    //////////////////////////////////////////////////////////////
  ];

  menus_l3 = [
    //
    {
      code: "detail_corporate_performance",
      title: "Performance",
      Url: "/cnce-corporate/dashboard/corporate/mes-performances",
      active: "",
      type: "dropdown_l3",
      permission: "dashboard_corporate_performances",
      header_id: "detail_corporate",
      current_header: ""
    },
    {
      code: "detail_corporate_production",
      title: "Production",
      Url: "/cnce-corporate/dashboard/corporate/production/production-for-all",
      active: "",
      type: "dropdown_l3",
      permission: "dashboard_corporate_production",
      header_id: "detail_corporate",
      current_header: ""
    },
    {
      code: "detail_corporate_productivite",
      title: "Productivité",
      Url:
        "/cnce-corporate/dashboard/corporate/productivite/productivite-for-agent",
      active: "",
      type: "dropdown_l3",
      permission: "dashboard_corporate_productivite",
      header_id: "detail_corporate",
      current_header: ""
    },
    {
      code: "detail_corporate_backoffice",
      title: "Backoffice",
      Url: "/cnce-corporate/dashboard/corporate/backoffice",
      active: "",
      type: "simple",
      permission: "dashboard_corporate_backoffice",
      header_id: "detail_corporate",
      current_header: ""
    },
    //
    {
      code: "detail_particulier_performance",
      title: "Performance",
      Url: "/retail/dashboard/particulier/mes-performances",
      active: "",
      type: "dropdown_l3",
      permission: "dashboard_particulier_performances",
      header_id: "detail_particulier",
      current_header: ""
    },
    {
      code: "detail_particulier_production",
      title: "Production",
      Url: "/retail/dashboard/particulier/production/production-for-all",
      active: "",
      type: "dropdown_l3",
      permission: "dashboard_particulier_production",
      header_id: "detail_particulier",
      current_header: ""
    },
    {
      code: "detail_particulier_productivite",
      title: "Productivité",
      Url: "/retail/dashboard/particulier/productivite/productivite-for-all",
      active: "",
      type: "dropdown_l3",
      permission: "dashboard_particulier_productivite",
      header_id: "detail_particulier",
      current_header: ""
    },
    {
      code: "detail_particulier_backoffice",
      title: "Backoffice",
      Url: "/retail/dashboard/particulier/backoffice",
      active: "",
      type: "simple",
      permission: "dashboard_particulier_backoffice",
      header_id: "detail_particulier",
      current_header: ""
    },
    //
    {
      code: "detail_professionnel_performance",
      title: "Performance",
      Url: "/cnce-professionnel/dashboard/professionnel/mes-performances",
      active: "",
      type: "dropdown_l3",
      permission: "dashboard_professionnel_performances",
      header_id: "detail_professionnel",
      current_header: ""
    },
    {
      code: "detail_professionnel_production",
      title: "Production",
      Url:
        "/cnce-professionnel/dashboard/professionnel/production/production-for-all",
      active: "",
      type: "dropdown_l3",
      permission: "dashboard_professionnel_production",
      header_id: "detail_professionnel",
      current_header: ""
    },
    {
      code: "detail_professionnel_productivite",
      title: "Productivité",
      Url:
        "/cnce-professionnel/dashboard/professionnel/productivite/productivite-for-agent",
      active: "",
      type: "dropdown_l3",
      permission: "dashboard_professionnel_productivite",
      header_id: "detail_professionnel",
      current_header: ""
    },
    {
      code: "detail_professionnel_backoffice",
      title: "Backoffice",
      Url: "/cnce-professionnel/dashboard/professionnel/backoffice",
      active: "",
      type: "simple",
      permission: "dashboard_professionnel_backoffice",
      header_id: "detail_professionnel",
      current_header: ""
    },
    //
    {
      code: "dossier_corporate_creerdossier",
      title: "Créer un dossier",
      Url: "/cnce-corporate/create-dossier-credit",
      active: "",
      type: "dropdown_l3",
      permission: "corporate_creerDossier",
      header_id: "dossier_corporate",
      current_header: ""
    },
    {
      code: "dossier_corporate_historiquedossier",
      title: "Historique des dossiers",
      Url: "/cnce-corporate/dossier-historique-all",
      active: "",
      type: "dropdown_l3",
      permission: "corporate_historiqueDossier",
      header_id: "dossier_corporate",
      current_header: ""
    },
    //
    {
      code: "dossier_particulier_creerdossier",
      title: "Créer un dossier",
      Url: "/retail/create-dossier-credit",
      active: "",
      type: "dropdown_l3",
      permission: "particulier_creerDossier",
      header_id: "dossier_particulier",
      current_header: ""
    },
    {
      code: "dossier_particulier_historiquedossier",
      title: "Historique des dossiers",
      Url: "/retail/dossier-historique-all",
      active: "",
      type: "dropdown_l3",
      permission: "particulier_historiqueDossier",
      header_id: "dossier_particulier",
      current_header: ""
    },
    //
    {
      code: "dossier_professionnel_creerdossier",
      title: "Créer un dossier",
      Url: "/cnce-professionnel/create-dossier-credit",
      active: "",
      type: "dropdown_l3",
      permission: "professionnel_creerDossier",
      header_id: "dossier_professionnel",
      current_header: ""
    },
    {
      code: "dossier_professionnel_historiquedossier",
      title: "Historique des dossiers",
      Url: "/cnce-professionnel/dossier-historique-all",
      active: "",
      type: "dropdown_l3",
      permission: "professionnel_historiqueDossier",
      header_id: "dossier_professionnel",
      current_header: ""
    },
    //
    {
      code: "dossier_contentieux_historiquedossier",
      title: "Historique des dossiers",
      Url: "/contentieux/dossier-historique",
      active: "",
      type: "dropdown_l3",
      permission: "contentieux_historiqueDossier",
      header_id: "dossier_contentieux",
      current_header: ""
    }
    //
  ];

  menus_l4 = [
    //
    {
      code: "detail_corporate_performance_mesperformances",
      title: "Mes performances",
      Url: "/cnce-corporate/dashboard/corporate/mes-performances",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_corporate_performance",
      current_header: ""
    },
    {
      code: "detail_corporate_performance_mesdossiers",
      title: "Mes dossiers",
      Url: "/cnce-corporate/dashboard/corporate/mes-dossiers",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_corporate_performance",
      current_header: ""
    },
    //
    {
      code: "detail_corporate_production_generale",
      title: "Générale",
      Url: "/cnce-corporate/dashboard/corporate/production/production-for-all",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_corporate_production",
      current_header: ""
    },
    {
      code: "detail_corporate_production_produit",
      title: "Produit",
      Url:
        "/cnce-corporate/dashboard/corporate/production/production-by-produit",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_corporate_production",
      current_header: ""
    },
    {
      code: "detail_corporate_production_secteur",
      title: "Secteur",
      Url:
        "/cnce-corporate/dashboard/corporate/production/production-by-secteur",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_corporate_production",
      current_header: ""
    },
    //
    {
      code: "detail_corporate_productivite_agent",
      title: "Agent",
      Url:
        "/cnce-corporate/dashboard/corporate/productivite/productivite-for-agent",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_corporate_productivite",
      current_header: ""
    },
    {
      code: "detail_corporate_productivite_sla",
      title: "Direction",
      Url: "/cnce-corporate/dashboard/corporate/productivite/sla-direction",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_corporate_productivite",
      current_header: ""
    },
    //
    {
      code: "detail_particulier_performance_mesperformances",
      title: "Mes performances",
      Url: "/retail/dashboard/particulier/mes-performances",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_particulier_performance",
      current_header: ""
    },
    {
      code: "detail_particulier_performance_mesdossiers",
      title: "Mes dossiers",
      Url: "/retail/dashboard/particulier/mes-dossiers",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_particulier_performance",
      current_header: ""
    },
    //
    {
      code: "detail_particulier_production_generale",
      title: "Générale",
      Url: "/retail/dashboard/particulier/production/production-for-all",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_particulier_production",
      current_header: ""
    },
    {
      code: "detail_particulier_production_agence",
      title: "Agence",
      Url: "/retail/dashboard/particulier/production/production-for-agence",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_particulier_production",
      current_header: ""
    },
    {
      code: "detail_particulier_production_reseau",
      title: "Réseau",
      Url: "/retail/dashboard/particulier/production/production-for-reseau",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_particulier_production",
      current_header: ""
    },
    {
      code: "detail_particulier_production_typecredit",
      title: "Type de crédit",
      Url: "/retail/dashboard/particulier/production/production-type-credit",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_particulier_production",
      current_header: ""
    },
    //
    {
      code: "detail_particulier_productivite_agent",
      title: "Agent",
      Url: "/retail/dashboard/particulier/productivite/productivite-for-all",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_particulier_productivite",
      current_header: ""
    },
    {
      code: "detail_particulier_productivite_sla",
      title: "Direction",
      Url: "/retail/dashboard/particulier/productivite/sla-direction",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_particulier_productivite",
      current_header: ""
    },
    {
      code: "detail_particulier_productivite_objectif",
      title: "Objectif",
      Url:
        "/retail/dashboard/particulier/productivite/objectif-type-credit-by-employee",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_particulier_productivite",
      current_header: ""
    },
    //
    {
      code: "detail_professionnel_performance_mesperformances",
      title: "Mes performances",
      Url: "/cnce-professionnel/dashboard/professionnel/mes-performances",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_professionnel_performance",
      current_header: ""
    },
    {
      code: "detail_professionnel_performance_mesdossiers",
      title: "Mes dossiers",
      Url: "/cnce-professionnel/dashboard/professionnel/mes-dossiers",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_professionnel_performance",
      current_header: ""
    },
    //
    {
      code: "detail_professionnel_production_generale",
      title: "Générale",
      Url:
        "/cnce-professionnel/dashboard/professionnel/production/production-for-all",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_professionnel_production",
      current_header: ""
    },
    {
      code: "detail_professionnel_production_produit",
      title: "Produit",
      Url:
        "/cnce-professionnel/dashboard/professionnel/production/production-by-produit",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_professionnel_production",
      current_header: ""
    },
    {
      code: "detail_professionnel_production_secteur",
      title: "Secteur",
      Url:
        "/cnce-professionnel/dashboard/professionnel/production/production-by-secteur",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_professionnel_production",
      current_header: ""
    },
    //
    {
      code: "detail_professionnel_productivite_agent",
      title: "Agent",
      Url:
        "/cnce-professionnel/dashboard/professionnel/productivite/productivite-for-agent",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_professionnel_productivite",
      current_header: ""
    },
    {
      code: "detail_professionnel_productivite_sla",
      title: "Direction",
      Url:
        "/cnce-professionnel/dashboard/professionnel/productivite/sla-direction",
      icon: "fa fa-bar-chart",
      active: "",
      permission: "for_all",
      type: "simple",
      header_id: "detail_professionnel_productivite",
      current_header: ""
    }
    //
  ];

  current_menu_l4: String = null;

  constructor() {}

  getMenuList() {
    return this.menus;
  }

  getMenuList_l2() {
    return this.menus_l2;
  }

  getMenuList_l3() {
    return this.menus_l3;
  }

  getMenuList_l4() {
    return this.menus_l4;
  }
}
